// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"bf828fc3","106":"e8ccf62c","118":"262a94d9","134":"e81288e9","192":"c0bc5d45","453":"bd6f81e6"}[chunkId] + ".chunk.js";
};